import { CoinIcon } from '@/shared/ui/icons'
import { useStyles } from './styles'
import { Spiner } from '@/shared/ui/spiner'
import { AccStatsListProps } from '../updateView/types'
import { PlusText } from '@/shared/ui/plusText'
import { formatNumber } from '@/shared/util/formatNumber'
import { Icon } from '@/shared/ui/icon'

export const AccStatsList = ({ propValue, isPlusUser }: AccStatsListProps) => {
  const { classes } = useStyles({})

  if (!propValue) {
    return <Spiner size="m" />
  }

  return (
    <div className={classes.root}>
      {propValue.map((item) => {
        const hasValue = item.value !== null && item.value !== undefined
        const isLocked = !isPlusUser && item.isPlus
        const hasReward = item.reward !== undefined && item.reward !== null && item.value === null

        return (
          <div
            className={classes.listItem}
            key={item.name}
          >
            <div className={classes.title}>
              <span className={classes.titleName}>{item.name}</span>
              {item.isPlus && <PlusText />}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
              {isLocked ? (
                <Icon
                  view="lock"
                  style={{ width: '18px' }}
                />
              ) : (
                <div className={classes.value}>
                  {hasValue ? (
                    <>
                      {formatNumber(item.value!)}
                      {item.unit && <span>&nbsp;{item.unit}</span>}
                    </>
                  ) : (
                    <Spiner size="s" />
                  )}
                </div>
              )}
              {hasReward && (
                <div style={{ width: 'fit-content' }}>
                  <div className={classes.revard}>
                    + {item.reward} <CoinIcon classes={{ root: classes.coinIcon }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
